/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The configuration of the animatic for a remote sump.
 */
export type AnimaticRemoteSumpConfig = {
  /**
   * Whether to flip the orientation of the remote sump.
   */
  flip?: boolean | undefined;
  /**
   * A reference to a reading or setting.
   */
  levelRef?: Ref | undefined;
};

/** @internal */
export const AnimaticRemoteSumpConfig$inboundSchema: z.ZodType<
  AnimaticRemoteSumpConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  flip: types.boolean().default(false),
  level_ref: types.optional(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "level_ref": "levelRef",
  });
});
/** @internal */
export type AnimaticRemoteSumpConfig$Outbound = {
  flip: boolean;
  level_ref?: Ref$Outbound | undefined;
};

/** @internal */
export const AnimaticRemoteSumpConfig$outboundSchema: z.ZodType<
  AnimaticRemoteSumpConfig$Outbound,
  z.ZodTypeDef,
  AnimaticRemoteSumpConfig
> = z.object({
  flip: z.boolean().default(false),
  levelRef: Ref$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    levelRef: "level_ref",
  });
});

export function animaticRemoteSumpConfigToJSON(
  animaticRemoteSumpConfig: AnimaticRemoteSumpConfig,
): string {
  return JSON.stringify(
    AnimaticRemoteSumpConfig$outboundSchema.parse(animaticRemoteSumpConfig),
  );
}
export function animaticRemoteSumpConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticRemoteSumpConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticRemoteSumpConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticRemoteSumpConfig' from JSON`,
  );
}
